export default __webpack_public_path__ + "static/media/cry-hysterical.d285b7ed.gif";